export default {
  partner:
    'Establece tu comisión de procesamiento de Stripe o confirma un margen del 0 %. Hasta entonces, tus restaurantes en Stripe no pueden salir en vivo.',
  partner_live_one:
    'Establece tu comisión de procesamiento de Stripe o confirma un margen del 0 %. Hasta entonces, tus restaurantes en Stripe no pueden salir en vivo y tu restaurante activo no recibe pagos online.',
  partner_live_other:
    'Establece tu comisión de procesamiento de Stripe o confirma un margen del 0 %. Hasta entonces, tus restaurantes en Stripe no pueden salir en vivo y tus {{count}} restaurantes activos no reciben pagos online.',
  restaurant:
    'Los pagos online están en pausa hasta que tu partner establezca su comisión de procesamiento. Los pagos en efectivo siguen funcionando.',
  cta: 'Establecer comisión',
};
